import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as Logo } from "../../assets/img/logo/crafting-ai-logo.svg";
import NavLink from "../NavLink";
import { DropdownButton, default as DropdownLink } from "../dashboard/DropdownLink";
import Dropdown from "../dashboard/Dropdown";
import {useNavigate, useLocation} from 'react-router-dom';

const Navbar = ({...props}) => {
  const navigate = useNavigate();

  const MobileNavigation = () => {
        return(
            <span className={"lg:hidden"}>
              <NavLink name="Introduction" url="/documentation/large-language-models" />

              <NavLink name="Prompt Engineering" url="/documentation/prompt-engineering#prompt-engineering" />

              <NavLink name="Framework Introduction" url="/documentation/framework/introduction" />

              <NavLink name="Framework" url="/documentation/framework#documentation" />
              <div className={"pl-7"}>
                <NavLink name="Crafting Phase" url="/documentation/framework#craft" />
                <NavLink name="Validation Phase" url="/documentation/framework#validate" />
                <NavLink name="Enhancement Phase" url="/documentation/framework#enhance" />
                <NavLink name="Cheatsheet" url="/documentation/framework/cheatsheet" />
              </div>

              <NavLink name="Framework IVPE" url="/documentation/framework/visual#documentation" />
              <div className={"pl-7"}>
                <NavLink name="Crafting Phase" url="/documentation/framework/visual#craft" />
                <NavLink name="Validation Phase" url="/documentation/framework/visual#validate" />
                <NavLink name="Enhancement Phase" url="/documentation/framework/visual#enhance" />
              </div>

              <NavLink name="Prompt Techniques" url="/documentation/prompt-techniques#prompt-techniques" />
              <div className={"pl-7"}>
                <NavLink name="Shot prompting" url="/documentation/prompt-techniques#zero-single-few-shot" />
                <NavLink name="Chain of Thought (CoT) prompting" url="/documentation/prompt-techniques#chain-of-thought-prompting" />
                <NavLink name="Emotional prompting" url="/documentation/prompt-techniques#emotional-prompting" />
              </div>

              <NavLink name="Adversarial Prompting" url="/documentation/adversarial-prompting#adversarial-prompting" />
              <div className={"pl-7"}>
                <NavLink name="Prompt Injections" url="/documentation/adversarial-prompting#prompt-injections" />
                <NavLink name="Prompt Leaking" url="/documentation/adversarial-prompting#prompt-leaking" />
                <NavLink name="Prompt Jailbreaking" url="/documentation/adversarial-prompting#prompt-jailbreaking" />
                <NavLink name="Risk and impact score" url="/documentation/adversarial-prompting#risk-impact-score" />
                <NavLink name="Adversarial prompts overview" url="/documentation/adversarial-prompting#prompt-injection-overview" />
              </div>
              <div className={"pl-7"}>
                <NavLink name="Prompt Injections" url="/documentation/adversarial-prompting/prompt-injections#prompt-injections" />
                <div className={"pl-7"}>
                  <NavLink name="Memory Manipulation" url="/documentation/adversarial-prompting/prompt-injections#memory-injection" />
                  <NavLink name="Website" url="/documentation/adversarial-prompting/prompt-injections#website-injection" />
                  <NavLink name="Image/Document" url="/documentation/adversarial-prompting/prompt-injections#image-injection" />
                </div>
                <NavLink name="Prompt Leaking" url="/documentation/adversarial-prompting/prompt-leaking#prompt-leaking" />
                <div className={"pl-7"}>
                  <NavLink name="Custom GPT" url="/documentation/adversarial-prompting/prompt-leaking#custom-gpt-leaking" />
                </div>
                <NavLink name="Prompt Jailbreaking" url="/documentation/adversarial-prompting/prompt-jailbreak#prompt-jailbreak" />
                <div className={"pl-7"}>
                  <NavLink name="ASCII Art-based" url="/documentation/adversarial-prompting/prompt-jailbreak#ASCII-Art-based-jailbreak" />
                  <NavLink name="Many-shot" url="/documentation/adversarial-prompting/prompt-jailbreak#many-shot-jailbreak" />
                </div>
              </div>

              <NavLink name="Prompt Architecture" url="/documentation/prompt-architecture#prompt-architecture" />
              <div className={"pl-7"}>
                <NavLink name="Prompt Libraries" url="/documentation/prompt-architecture#prompt-libraries-overview" />
                <NavLink name="Software Engineering perspective" url="/documentation/prompt-architecture#software-engineering-perspective" />
                <NavLink name="Prompt component library" url="/documentation/prompt-architecture#prompt-component-library" />
                <NavLink name="Prompt recipes" url="/documentation/prompt-architecture#prompt-recipes" />
                <NavLink name="Workflow prompting" url="/documentation/prompt-architecture#prompt-workflows" />
                <NavLink name="Framework integration" url="/documentation/prompt-architecture#framework-integration" />
              </div>

                {userIsLoggedIn() ?
                    <>
                        <NavLink name="Applications" url="/documentation/applications/" />
                        <div className={"pl-7"}>
                        <NavLink name="Coding with AI" url="/documentation/applications/coding" />
                        <NavLink name="ChatGPT" url="/documentation/applications/chatgpt#chatgpt" />
                        </div>
                        <NavLink name="Tools" url="/tools#tools" />
                    </> : <NavLink name="Tools" url="/tools#tools" /> }

            </span>
        );
  }

  const LoginRequired = () => {
    return !userIsLoggedIn() ? (
      <span className="ml-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-gradient-to-r from-indigo-500 to-blue-500 text-white text-xs font-medium shadow-sm">
        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
        </svg>
        Login
      </span>
    ) : null;
  }

  const DesktopNavigation = () => {
  const location = useLocation();
  const isDocumentationActive = location.pathname.startsWith('/documentation');
  
  return (
    <>
      <span className={"hidden lg:block"}>
        <Dropdown
          align="right"
          width={48}
          noTransition={true}
          trigger={(isOpen: boolean) => (
            <button className={`inline-flex items-center px-4 py-2 rounded-lg text-sm font-sans focus:outline-none 
              ${isDocumentationActive ? 'text-sky-900 dark:text-white font-bold' : 'text-[#666666] dark:text-white'} 
              hover:text-gray-900 dark:hover:text-gray-400
              ${isOpen ? 'bg-blue-50 border-blue-200 dark:bg-slate-800 dark:border-slate-700' : 'border-transparent'}
              hover:bg-blue-50 dark:hover:bg-slate-800 hover:border-blue-200 dark:hover:border-slate-700
              border transition-all duration-200`}>
              Documentation
              <svg className="ml-1 h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" clipRule="evenodd" />
              </svg>
            </button>)
          }
        >
          <div className="fixed top-20 left-0 right-0 z-[9999] mx-auto bg-white dark:bg-slate-900 rounded-xl shadow-xl border border-gray-100 dark:border-slate-800 overflow-hidden overflow-x-auto w-[min(calc(100vw-4rem),72rem)] max-w-6xl" style={{margin: '25px auto 0 auto'}}>
            {/* Decorative gradient accent */}
            <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-400 to-blue-600"></div>
          
          <h2 className="text-2xl font-semibold mb-4 mx-12 mt-8 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-2 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
            Documentation
          </h2>
          
            <div className="grid grid-cols-3 gap-6 px-8 pb-8 min-h-[18rem] relative">
              {/* Vertical dividers between columns */}
              <div className="absolute top-4 bottom-8 left-1/3 w-px bg-gradient-to-b from-transparent via-gray-200 dark:via-slate-700 to-transparent transform -translate-x-1/2"></div>
              <div className="absolute top-4 bottom-8 left-2/3 w-px bg-gradient-to-b from-transparent via-gray-200 dark:via-slate-700 to-transparent transform -translate-x-1/2"></div>
              
              {/* Left column */}
              <div className="col-span-1 space-y-4 group">
                <DropdownLink to="/documentation/large-language-models#llms" showActive={true}>
                  <span className="font-semibold text-base">Introduction</span>
                  <span className="block text-xs text-gray-500">LLM's, Tokens, Context Window</span>
                </DropdownLink>
                <DropdownLink to="/documentation/prompt-engineering#prompt-engineering" showActive={true}>
                  <span className="font-semibold text-base">Prompt Engineering</span>
                  <span className="block text-xs text-gray-500">Prompt Engineering, IPE, IVPE and SPE</span>
                </DropdownLink>
                <DropdownLink to="/documentation/framework/introduction#introduction" showActive={true}>
                  <span className="font-semibold text-base">Framework Introduction</span>
                  <span className="block text-xs text-gray-500">Crafting prompts with IPE/IVPE following the Crafting AI Prompts Framework</span>
                </DropdownLink>
                <DropdownLink to="/documentation/framework#documentation" className="pl-12" showActive={true}>
                  <span className="font-semibold text-base">IPE Framework</span>
                  <span className="block text-xs text-gray-500">Crafting AI Prompts Framework for textual output</span>
                </DropdownLink>
                <DropdownLink to="/documentation/framework/visual#documentation" className="pl-12" showActive={true}>
                  <span className="font-semibold text-base">IVPE Framework</span>
                  <span className="block text-xs text-gray-500">Crafting AI Prompts Framework for visual output</span>
                </DropdownLink>
              </div>
              
              {/* Middle column */}
              <div className="col-span-1 space-y-4 group">
                <DropdownLink to="/documentation/prompt-techniques#prompt-techniques" showActive={true}>
                  <span className="font-semibold text-base">Prompt Techniques</span>
                  <span className="block text-xs text-gray-500">Prompt Engineering Techniques for LLMs</span>
                </DropdownLink>
                <DropdownLink to="/documentation/prompt-techniques#zero-single-few-shot" className="pl-12" showActive={true}>
                  <span className="font-semibold text-base">Shot Prompting</span>
                  <span className="block text-xs text-gray-500">Zero-shot, Single-shot and Few-shot Prompting</span>
                </DropdownLink> 
                <DropdownLink to="/documentation/prompt-techniques#chain-of-thought-prompting" className="pl-12" showActive={true}>
                  <span className="font-semibold text-base">Chain-of-Thought Prompting</span>
                  <span className="block text-xs text-gray-500">Break down a complex question or problem into a series of steps.</span>
                </DropdownLink> 
                <DropdownLink to="/documentation/prompt-techniques#emotional-prompting" className="pl-12" showActive={true}>
                  <span className="font-semibold text-base">Emotional Prompting</span>
                  <span className="block text-xs text-gray-500">Adding emotional elements to prompts.</span>
                </DropdownLink>
                <DropdownLink to="/documentation/adversarial-prompting#adversarial-prompting" showActive={true}>
                  <span className="font-semibold text-base">Adversarial Prompting</span>
                  <span className="block text-xs text-gray-500">How LLMs are abused</span>
                </DropdownLink>
              </div>
              
              {/* Right column */}
              <div className="col-span-1 space-y-4 group">
                <DropdownLink to="/documentation/prompt-architecture#prompt-architecture" showActive={true}>
                  <span className="font-semibold text-base">Prompt Architecture</span>
                  <span className="block text-xs text-gray-500">Storing and sharing prompts smart across your organisation or team</span>
                </DropdownLink>
                <DropdownLink to="/documentation/applications#applications" showActive={true}>
                  <span className="font-semibold text-base">Applications <LoginRequired /></span>
                  <span className="block text-xs text-gray-500">Use cases and examples</span>
                </DropdownLink>
                <DropdownLink to="/documentation/applications/coding#coding" className="pl-12" showActive={true}>
                  <span className="font-semibold text-base flex items-center gap-2">Coding with AI <LoginRequired /></span>
                  <span className="block text-xs text-gray-500">How to use LLMs for Software Engineering, Vibe & AmpCoding</span>
                </DropdownLink>
                <DropdownLink to="/documentation/applications/chatgpt#chatgpt" className="pl-12" showActive={true}>
                  <span className="font-semibold text-base">ChatGPT <LoginRequired /></span>
                  <span className="block text-xs text-gray-500">Extra information regarding ChatGPT</span>
                </DropdownLink>

                <DropdownLink to="/tools" showActive={true}>
                  <span className="font-semibold text-base">Tools <LoginRequired /></span>
                  <span className="block text-xs text-gray-500">Generative AI tools and ratings</span>
                </DropdownLink>
              </div>
            </div>
          </div>
        </Dropdown>
      </span>
      <span className={"hidden lg:block"}>
        <NavLink name="Tools" url="/tools" />
      </span>
    </>
  );
}

  const userIsLoggedIn = () => {
      return !(localStorage.getItem("username") === "" || localStorage.getItem("username") === undefined || localStorage.getItem("username")  === null);
  }

  return (
      <nav id="navbar" className={`relative z-50 w-full text-neutral-800 dark:bg-slate-900 dark:text-white`}>
        <div className="flex flex-col max-w-screen-xl px-8 mx-auto lg:items-center lg:justify-between lg:flex-row py-4">
          <div className="flex flex-col lg:flex-row items-center space-x-4 xl:space-x-8">
            <div className="w-full flex flex-row items-center justify-between py-6">
              <div>
                <a href={"/"} title="Crafting AI Prompts Framework"><Logo /></a>
              </div>
                <button
                    className="rounded-lg lg:hidden focus:outline-none focus:shadow-outline relative w-6 h-6"
                    onClick={() => { props.toggleSidebar(!props.open); }}
                >
                    <span className={`absolute block w-full h-0.5 bg-current transform transition-all duration-300 ease-in-out ${props.open ? 'rotate-45 ' : '-translate-y-2'}`}></span>
                    <span className={`absolute block w-full h-0.5 bg-current transform transition-all duration-300 ease-in-out ${props.open ? 'opacity-0' : 'opacity-100'}`}></span>
                    <span className={`absolute block w-full h-0.5 bg-current transform transition-all duration-300 ease-in-out ${props.open ? '-rotate-45' : 'translate-y-2'}`}></span>
                </button>
            </div>
            <div className={"w-full h-auto flex flex-col flex-grow lg:items-center relative"}>
              <ul
                className={`${
                  props.open ? "flex" : "hidden lg:flex"
                } w-full h-auto flex flex-col flex-grow lg:items-center pb-4 lg:pb-0 lg:justify-end lg:flex-row origin-top duration-300 xl:space-x-2 space-y-3 lg:space-y-0`}
              >
                <NavLink name="Home" url="/" />

                <MobileNavigation />

                <DesktopNavigation />

                <NavLink name="Certification" url="/test" />

                <NavLink name="Resources" url="/resources" />

                <span className={"lg:hidden block"}>
                    {!userIsLoggedIn() ?
                        <NavLink name="Login" url="/login" />
                        : <span className={"py-3 block"}>
                            <NavLink name={localStorage.getItem("username") + ""} url="/dashboard/profile" />
                            <NavLink name="Dashboard" url="/dashboard/overview" />

                            <li className="w-full">
                              <button
                                  className="md:px-4 font-sans py-2 text-sm bg-transparent rounded-lg text-[#666666] dark:text-white hover:text-gray-900 hover:dark:text-gray-400"
                                  onClick={() => navigate('/logout')}
                              >
                                Logout
                              </button>
                            </li>
                          </span>
                    }

                    <NavLink name="Contact" url="/contact" />
                </span>

                <li className={"w-full"}>
                  <button onClick={props.toggleDarkMode} id="theme-toggle"
                     className="cursor-pointer lg:hidden md:px-4 font-sans text-sm bg-transparent rounded-lg text-[#666666] dark:text-white hover:text-gray-900 hover:dark:text-gray-400"
                  >
                    <span id="theme-toggle-dark-icon-mob" className="z w-5 h-5">Dark mode</span>
                    <span id="theme-toggle-light-icon-mob" className="hidden w-5 h-5">Light mode</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <div className={"hidden lg:flex"}>
            {/* Settings Dropdown */}
            {
                !userIsLoggedIn() || localStorage.getItem("username") === undefined || localStorage.getItem("username")  === "undefined" ?
                  <button onClick={() => navigate("/login")} className="flex items-center text-sm font-medium
             text-gray-500 hover:text-gray-700 focus:outline-none
             transition duration-150 ease-in-out mr-5">Login</button>
                  :
                  <div className="hidden sm:flex sm:items-center sm:ml-6 mr-5">
                    <Dropdown
                        align="right"
                        width={96}
                        trigger={(isOpen: boolean) => (
                          <button className={`flex items-center text-sm font-sans px-4 py-2 rounded-lg focus:outline-none min-w-[120px] w-auto justify-between
                                            ${isOpen ? 'bg-blue-50 border-blue-200 dark:bg-slate-800 dark:border-slate-700' : 'border-transparent'}
                                            hover:bg-blue-50 dark:hover:bg-slate-800 hover:border-blue-200 dark:hover:border-slate-700
                                            border transition-all duration-200`}>
                            <div className="flex items-center">
                              <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-blue-600 dark:bg-slate-700 dark:text-blue-400 mr-2 font-medium">
                                {localStorage.getItem("username")?.charAt(0).toUpperCase()}
                              </div>
                              <div className="text-gray-700 dark:text-white font-medium">{ localStorage.getItem("username")}</div>
                              {localStorage.getItem("open_tickets") !== undefined && localStorage.getItem("open_tickets") !== null && localStorage.getItem("open_tickets") !== "0" &&
                                  <div className="relative group">
                                    <span className="ml-2 bg-sky-500 dark:bg-sky-700 text-white text-xs font-bold rounded-full px-2 py-1">
                                        {localStorage.getItem("open_tickets")}
                                    </span>
                                    <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 hidden group-hover:block bg-gray-700 text-white text-xs rounded py-4 px-6 max-w-lg w-max sm:left-1/2 sm:-translate-x-1/2 lg:left-auto lg:right-0 lg:-translate-x-0">
                                        These are tickets that are still open and require action.
                                    </span>
                                  </div>
                              }
                              {localStorage.getItem("total_open_tickets") !== undefined && localStorage.getItem("total_open_tickets") !== null && localStorage.getItem("total_open_tickets") !== "0" &&
                                <div className="relative group">
                                <span className="ml-2 bg-red-500 dark:bg-red-900 text-white text-xs font-bold rounded-full px-2 py-1">
                                    {localStorage.getItem("total_open_tickets")}
                                </span>
                                <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 hidden group-hover:block bg-gray-700 text-white text-xs rounded py-4 px-6 max-w-lg w-max sm:left-1/2 sm:-translate-x-1/2 lg:left-auto lg:right-0 lg:-translate-x-0">
                                    These are tickets that are still pending and require moderation.
                                </span>
                              </div>
                              }
                            </div>
                            <div className="ml-1">
                              <svg
                                  className="fill-current h-4 w-4 text-gray-500 group-hover:text-blue-600 dark:text-gray-400 dark:group-hover:text-blue-400 transition-colors duration-200"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20">
                                <path
                                    fillRule="evenodd"
                                    // eslint-disable-next-line max-len
                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          </button>)
                        }>
                      {/* Decorative gradient accent */}
                      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-400 to-blue-600"></div>
                      
                      <div className="p-5 border-b border-gray-100 dark:border-slate-700">
                        <div className="flex items-center">
                          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-100 text-blue-600 dark:bg-slate-700 dark:text-blue-400 mr-3 font-medium text-base">
                            {localStorage.getItem("username")?.charAt(0).toUpperCase()}
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="font-medium text-gray-800 dark:text-white text-base truncate max-w-[200px]">{localStorage.getItem("username")}</div>
                            <div className="text-xs text-gray-500 dark:text-gray-400 whitespace-nowrap">Logged in</div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="py-2 px-1">
                        <DropdownButton onClick={() => navigate("/dashboard/overview")} className="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2 text-blue-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                          </svg>
                          <span className="whitespace-nowrap">Dashboard</span>
                        </DropdownButton>
                        <DropdownButton onClick={() => navigate("/dashboard/profile")} className="flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2 text-blue-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                          </svg>
                          <span className="whitespace-nowrap">Profile</span>
                        </DropdownButton>
                      </div>
                      
                      <div className="border-t border-gray-100 dark:border-slate-700 py-2 px-1">
                        <DropdownButton onClick={() => navigate('/logout')} className="flex items-center text-red-600 dark:text-red-400">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                          </svg>
                          <span className="whitespace-nowrap">Logout</span>
                        </DropdownButton>
                      </div>
                    </Dropdown>
                  </div>
            }
            {/* ENABLE IF DARK/LIGHT MODE SWITCH SHOULD BE IN */}
            <button onClick={props.toggleDarkMode} id="theme-toggle" type="button"
                    className="hidden lg:flex text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 focus:outline-none focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 rounded-lg text-sm p-2.5">
              <svg id="theme-toggle-dark-icon" className="z w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"></path>
              </svg>
              <svg id="theme-toggle-light-icon" className="hidden w-5 h-5" fill="currentColor" viewBox="0 0 20 20"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"></path>
              </svg>
            </button>
          </div>
        </div>
      </nav>
  );
};

export default Navbar;
